<template>
  <div>
    <Header />
    <!-- <div class="main-content">
      <div class="text-center">
        <img :src='require("@/assets/images/" + this.logo)' alt="logo">
        <h1 v-if="this.description !== ''">{{this.description}}</h1>
      </div>
    </div> -->
    <div class="container">
      <div class="shop-container">
        <h2 class="total-point">{{ number_with_commas(cart.current_reward_points) }} Total Points</h2>
        <div class="product-category-container">
          <div class="product-category" v-for="(category, i) in categories" :key="'product-category' + i">
            <div @click="scrollToCategory(category.link)">{{ category.name }}</div>
          </div>
        </div>
        <div v-for="(category, i) in new_page_detail" :key="'category' + i" :id="'category' + i">
          <div v-for="(productbox_category, index) in category.productbox" :key="'product' + index" class="product-container">
            <div class="product-preview-container" v-if="productbox_category.detail">
              <div class="w-100 text-center">
                <img v-if="get_preview_product(productbox_category.detail)[0].photourl !== ''" :src="get_preview_product(productbox_category.detail)[0].photourl" alt="no-image">
                <img v-else :src="require('@/assets/images/no_image_available.png')" width="300" />
              </div>
              <div class="w-100">
                <h2>{{productbox_category.category_name}}</h2>
                <p>{{ productbox_category.subtitle }}</p>

                <ul v-for="(bullet_point, index) in productbox_category.bullet_points" :key="'bullet_point' + index">
                  <li>{{bullet_point}}</li>
                </ul>

                <h1 class="product-detail-price">{{ get_preview_product(productbox_category.detail)[0].quantity_price[0].unit_price }}</h1>
              </div>
            </div>
            <div class="product-slider" v-if="get_preview_product(productbox_category.detail).length > 1">
              <img
                v-for="product in productbox_category.detail"
                :key="product.sort"
                :src="product.photourl !== '' ? product.photourl : require('@/assets/images/no_image_available.png')"
                alt="no-image"
                :style="{ width: 100 / get_preview_product(productbox_category.detail).length + '%' }"
              />
            </div>
            <table class="table rounded-corners mt-3">
              <thead>
                <tr>
                  <th class="text-center">Flavor</th>
                  <!-- <th v-if="productbox_category.show_strain === 1">Strain</th> -->
                  <th class="text-center">Effect</th>



                  <template v-if="mixed_cases === 1" >
                    <th class="text-center">Quantity</th>
                    <th class="text-center">Price $</th>

                  </template>
                  <template v-else>

                    <template v-if="half_cases === 0">

                      <template v-if="no_cases === 1">
                        <th class="text-center">Qty Item</th>
                        <th class="text-center">$ / Unit</th>
                      </template>
                      <template v-else>
                        <th class="text-center">Qty / Case</th>
                        <th class="text-center">$ / Case</th>
                      </template>

                    </template>
                    <template v-else>

                      <th class="text-center">Qty / Half Case</th>
                      <th class="text-center">$ / Half Case </th>

                    </template>

                  </template>

                  <th class="text-center">Reward Points</th>
                  <th class="text-center">Amount</th>
                  <th class="text-center" style="width: 150px">ADD TO CART</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(productbox, i) in get_preview_product(productbox_category.detail)" v-bind:key="productbox.sort + i">
                  <td style="white-space:nowrap;">{{productbox.productname}}</td>
                  <!-- <td v-if="productbox_category.show_strain === 1" style="white-space:nowrap;">{{productbox.strain}}</td> -->
                  <td style="white-space:nowrap;" class="text-center font-weight-bold">{{productbox.effect}}</td>


<!--               Mixed full / half / single need each line and not combined field-->
                  <template v-if="mixed_cases === 0 || productbox.quantity_price[0].same_in_group === 1" >
                    <td class="text-center" :rowspan="get_preview_product(productbox_category.detail).length" v-if="i === 0">
                      <h4 class="mb-0">{{productbox.quantity_price[0].qty_cs}}</h4>
                    </td>
                    <td class="text-center" :rowspan="get_preview_product(productbox_category.detail).length" v-if="i === 0">
                      <h4 class="mb-0">{{productbox.quantity_price[0].price}}</h4>
                    </td>
                  </template>
                  <template v-else>
                    <td class="text-center">
                      <h4 class="mb-0">{{productbox.quantity_price[0].qty_cs}}</h4>
                    </td>
                    <td class="text-center">
                      <h4 class="mb-0">{{productbox.quantity_price[0].price}}</h4>
                    </td>
                  </template>


                  <td class="reward-points text-center" style="white-space:nowrap;">
                    <span>{{productbox.reward_points}}</span>
                  </td>
                  <td style="white-space:nowrap;" class="text-center">

                  <h5 class="mb-0" v-if="productbox.is_amount == true">{{productbox.price_total}}</h5>

                  </td>
                  <td>
                    <div class="add-to-cart">
                      <input
                        type="number"
                        id="quantity"
                        class="form-control"
                        :value="productbox.quantity"
                        @input="productbox.quantity = $event.target.value"
                        @keyup="set_amount_product_quantity(productbox.productid,productbox.quantity)"
                      >
                      <template v-if="productbox.quantity > 0">
                        <button @click="set_amount_product_quantity(productbox.productid,productbox.quantity,true)">Update</button>
                      </template>
                      <template v-else>
                        <button @click="set_amount_product_quantity(productbox.productid,productbox.quantity,true)">Add</button>
                      </template>
                    </div>
                  </td>
                </tr>
              </tbody>
              <!-- <tfoot v-if="set_page_number === 1">
                <tr>
                  <td colspan="7">
                    <h3 class="mb-0 font-weight-black">{{productbox_category.category_name}}</h3>
                  </td>
                </tr>
              </tfoot> -->
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="point-box" v-if="cart && cart.items.length">
      <h4>Points In Cart</h4>
      <h2>{{ number_with_commas(cart.total_reward_points) }}</h2>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Header from '@/components/header'

export default {
  components: {
    Header
  },
  data() {
    return {
      page_data: [],
      set_page_number: 0,
      header_quantity: [],
      description: "",
      categories: [
        {name: "Froot", link: "category0"},
        {name: "Sparkiez", link: "category2"},
        {name: "Noah's", link: "category1"}
      ],
      new_page_detail: [],
    }
  },
  props: {
    page_group : null,
  },
  created() {
    if(!this.signedIn) {
      this.$router.push({name: 'login'})
    } else {
      this.$store.dispatch('cart/loadShoppingCart');
      this.change_category_order();
    }
  },
  watch: {
    cart: async function() {
      // This sets all 3 pages for having all pages on one. CN 2/5/2024
      for(var p = 1; p < this.pages_products.all_product_locations.length; p++) {
        this.set_product_page(p);
      }
    }
  },
  mounted() {

    // Info: This is redundant if we only use one page CN 2/5/2024
    // if(this.page_group) {
    //   this.set_page_number = this.page_group;
    // } else {
    //   this.set_page_number = 1; // default if not set
    // }
    // this.set_product_page(this.set_page_number);

  },
  computed: {
    ...mapGetters({
      half_cases: 'auth/getHalfCases',
      no_cases:'auth/getNoCases',
      mixed_cases: 'auth/getMixedCases',
      signedIn: 'auth/signedIn',
      getEnvironment: 'cart/getEnvironment',
      cart: 'cart/getCart',
      pages_products: 'cart/pages_products',
    })
  },
  methods: {
    set_cart_quantity() {
      for(var p = 0; p < this.pages_products.all_product_locations.length; p++) {
        if(this.pages_products.all_product_locations[p].page === this.set_page_number) {

          var product_location = this.pages_products.all_product_locations[p];
          let category_group = product_location.category_group;
          let detail_product = product_location.detail_product;

          let cart_item = this.cart.items.find(o => o.sku === product_location.sku);

          if (cart_item) {
            this.page_data.productbox[category_group].detail[detail_product].reward_points = cart_item.reward_points;
            this.page_data.productbox[category_group].detail[detail_product].quantity = cart_item.quantity;
            this.page_data.productbox[category_group].detail[detail_product].price_total = cart_item.price_total;
            this.page_data.productbox[category_group].detail[detail_product].is_reward = cart_item.is_reward;
            this.page_data.productbox[category_group].detail[detail_product].is_amount = cart_item.is_amount;
          } else {
            this.page_data.productbox[category_group].detail[detail_product].reward_points = '';
            this.page_data.productbox[category_group].detail[detail_product].quantity = '';
            this.page_data.productbox[category_group].detail[detail_product].price_total ='';
          }
        }
      }
    },
    set_product_page(page_number) {
      this.set_page_number = page_number;
      this.pages_products.page_detail.forEach((detail_page) => {
        if(detail_page.page_number === page_number) {
          this.page_data = detail_page;
          if(detail_page.productbox.length > 0){
            detail_page.productbox.forEach((productbox) => {
              this.header_quantity = [];
              productbox.quantity_price.forEach((quantity_price) => {
                this.header_quantity.push(quantity_price.quantity + quantity_price.quantity_plus);
              });
            });
          }
        }
      });
      this.set_cart_quantity();
    },
    set_amount_product_quantity: function (productid,quantity) {
      this.$store.dispatch('cart/setAmountCartProductQuantity', {productid,quantity})
    },
    set_reward_product_quantity: function (productid,quantity) {
      this.$store.dispatch('cart/setRewardCartProductQuantity', {productid,quantity})
    },
    get_preview_product(product){
      if(Array.isArray(product)){
        return product
      }else{
        return Object.values(product)
      }
    },
    change_category_order() {
      let original_page_detail = this.pages_products.page_detail;
      let order = [2, 1, 3];
      if (original_page_detail.length > 0) {
        this.new_page_detail = original_page_detail.sort((a, b) => {
          return order.indexOf(a.page_number) - order.indexOf(b.page_number);
        });
      }
    },
    number_with_commas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    scrollToCategory(link) {
      const targetElement = document.getElementById(link);
      if (targetElement) {
        const yOffset = targetElement.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({ top: yOffset, behavior: 'smooth' });
      }
    },
  }
}
</script>

<style scoped lang="scss">
  @font-face {
    font-family: "Neue75Bold";
    src: url('../../assets/fonts/Neue-Haas-Grotesk-Display-Pro-75-Bold.ttf') format("truetype");
  }

  @font-face {
    font-family: "NeueLight";
    src: url('../../assets/fonts/neue-haas-grotesk/NeueHaasDisplayLight.ttf') format("truetype");
  }

  h1{
    font-family: "Neue75Bold";
    font-weight: 900;
    margin: 50px 0 30px;
  }

  p{
    font-size: 20px;
  }

  .add-to-cart{
    display: flex;
    align-items: center;
    justify-content: center;
    input{
      color: #000000;
      border: 0.5px solid #000000;
      font-family: "NeueLight";
      font-weight: 600;
      font-size: 14px;
      line-height: 16px;
      height: 22px;
      width: 60px;
      padding: 5px;
      margin-right: 0.5rem;
      border-radius: 5px;
      &#sparkiez-quantity{
        border-radius: 0;
        width: 100%;
        max-width: 270px;
        margin-right: 0;
        height: 54px;
        border: 1px solid #000000;
      }
    }
    i{
      font-size: 36px;
      padding: 8px;
      border: 1px solid #000000;
      border-left: 0;
      cursor: pointer;
      height: 100%;

    }
    button{
      border: 0.5px solid #FF0000;
      text-transform: uppercase;
      font-size: 14px;
      font-weight: bold;
      background-color: transparent;
    }
  }

  table{
    margin-bottom: 3rem;
  }
</style>
